import { isValid } from "../formats";

export default function createURL(pathname: string, searchParams?: { name: string, value: string | number }[]) {
    const url = new URL(process.env.REACT_APP_BACK_URI||"");
    url.pathname += pathname;
    if (searchParams) {
        searchParams.forEach(({name, value}) => {
            if(name === "order") url.searchParams.append(name, orderSQL2NoSQL(value.toString()));
            else if(isValid(value)) url.searchParams.append(name, value.toString());
        })
    }
    return url.toString();
}

export function orderSQL2NoSQL(order: string) {

    let direc = 0;
    if (order.toUpperCase().endsWith("ASC")) direc = 1;
    else direc = -1;
    return `${order.split(" ")[0]} ${direc}`;
  }